import { toast } from 'react-toastify';
import { getItem } from './localStorage';

const otpErrors: Record<string, Record<string, string>> = {
  en: {
    INVALID_COUNTRY: 'Only Qatar phone numbers are accepted.',
    PHONE_RATE_LIMIT: 'Too many attempts for this number. Please wait 10 minutes before trying again.',
    IP_RATE_LIMIT: 'Too many requests from your connection. Please try again in an hour.',
    OTP_SEND_FAILED: 'We could not send the verification code. Please try again.',
    DEFAULT: 'Something went wrong. Please try again.',
  },
  ar: {
    INVALID_COUNTRY: 'يُقبل رقم هاتف قطري فقط.',
    PHONE_RATE_LIMIT: 'لقد تجاوزت الحد المسموح به. يرجى الانتظار 10 دقائق قبل المحاولة مجدداً.',
    IP_RATE_LIMIT: 'طلبات كثيرة من اتصالك الحالي. يرجى المحاولة مجدداً بعد ساعة.',
    OTP_SEND_FAILED: 'تعذّر إرسال رمز التحقق. يرجى المحاولة مجدداً.',
    DEFAULT: 'حدث خطأ ما. يرجى المحاولة مجدداً.',
  },
};

const getOtpErrorMessage = (code: string, lang: string): string => {
  const map = otpErrors[lang] || otpErrors.en;
  return map[code] || map.DEFAULT;
};

export const toastHandler = (err: any) => {
  const userInfo = getItem('info');
  const lang = userInfo?.language === 'ar' ? 'ar' : 'en';
  const errorCode = err?.data?.errorCode || err?.errorCode || err?.data?.code || err?.code;

  if (typeof errorCode === 'string' && otpErrors.en[errorCode]) {
    return toast.error(getOtpErrorMessage(errorCode, lang));
  }

  if (err?.errors && typeof err.errors === 'object') {
    const keys = Object.keys(err.errors);
    if (keys?.length > 0) {
      if (err?.errors[keys[0]]?.message) {
        return toast.error(err?.errors[keys[0]]?.message);
      } else {
        return toast.error(err?.errors[keys[0]]);
      }
    }
  }
  return toast.error(err?.message || 'An error occurred');
};
